import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import { variants } from '../../../variants/variants';

const UserProfileHeader = ({ user }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        width: '100%',
        p: 2,
        backgroundColor: 'background.paper',
        mb: '3px',
      }}
    >
      <UserAvatar src={user[5]} sx={{ width: 56, height: 56 }} />
      <Box sx={{ ml: 2 }}>
        <Typography sx={{ fontSize: variants.BODY, fontWeight: 600 }}>{user[2]}</Typography>
        <Typography sx={{ fontSize: variants.TINY, color: 'text.secondary' }}>{user[6]}</Typography>
        <Typography sx={{ fontSize: variants.BODY }}>{user[7]}</Typography>
      </Box>
    </Stack>
  );
};

export default UserProfileHeader;
